import { MultiSelect } from "primereact/multiselect";
import React from "react";
import "./styles/MultiselectZegel.scss";

const MultiselectZegel = (props) => {


  return (
    <MultiSelect
      {...props}
      className="mselect-zegel"
      showSelectAll={false}
      panelHeaderTemplate={<></>}
    >
    </MultiSelect>


  );
};






export default MultiselectZegel;
